import "@hotwired/turbo-rails";
import * as Turbo from "@hotwired/turbo";

Turbo.config.drive.progressBarDelay = 300;
